import { connect } from 'react-redux';

import { openModal as openModalAction } from 'components/Modal';

import StaffAccountItem from './StaffAccountItem';

const mapDispatchToProps = {
  openModal: openModalAction,
};

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { account } = ownProps;
  const { openModal } = dispatchProps;

  return {
    ...ownProps,
    ...dispatchProps,
    openModal: openModal.bind(null, 'EditStaffAccountModal', { account }),
  };
}

export default connect(null, mapDispatchToProps, mergeProps)(StaffAccountItem);
